import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;
import vuexStorage from '../store/index.js'

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//Fonction de téléchargement des CDR
async function downloadCdr(){
    try {
        await requestApi({method: 'GET', url: '/api/fileExist?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        toasterSuccess(`Fichier CDR déjà existant`,'Récupération des CDR')
        return true
    } catch (error){
        try {
            await requestApi({method: 'GET', url: '/api/downloadCdr?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
            toasterSuccess(`Téléchargement des données avec succès`,'Récupération des CDR')
            return true
        } catch (error) {
            console.log(error)
            if(error.response != undefined){
                toasterError(`Impossible de récupérer les données`,'Récupération des CDR')
                if(error.response.status!=404){
                    this.$router.push('/')
                }
            }else{
                toasterError(`Le service est momentanément indisponible`,'Service indisponible')
            }
            return false
        }
    }
}

//Fonction de création des factures brouillons
async function createDraftInvoices(syntec){
    try {
        let data = await requestApi({method: 'POST', url: '/api/createDraftInvoices?nocache=' + new Date().getTime(), params: {}, form: {syntec:syntec}, headers: {'Content-Type': 'application/json'}})
        toasterSuccess(`Création des factures brouillons réussie`,'Création des factures')
        vuexStorage.commit('setInvoicesContracts', data)
        return true
    } catch (error) {
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de créer les factures brouillons`,'Création des factures')
            if(error.response.status!=404){
                this.$router.push('/')
            }
            return false
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
        return false
    }
}

//Fonction de valorisation
async function valorisation(){
    let data = vuexStorage.state.invoicesContracts
    try {
        await requestApi({method: 'POST', url: '/api/valorisation?nocache=' + new Date().getTime(), params: {}, form: {data:data}, headers: {'Content-Type': 'application/json'}})
        toasterSuccess(`Valorisation des consommations avec succès`,'Valorisation')
        return true
    } catch (error){
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de valoriser les consommations`,'Valorisation')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
        return false
    }
}

//Fonction de suppression des factures brouillons
async function deleteDraftInvoices(){
    try {
        await requestApi({method: 'DELETE', url: '/api/deleteDraftInvoices?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
        toasterSuccess(`Suppression des factures brouillons avec succès`,'Suppression des brouillons')
        return true
    } catch (error){
        console.log(error)
        if(error.response != undefined){
            toasterError(`Impossible de supprimer les factures brouillons`,'Suppression des brouillons')
            if(error.response.status!=404){
                this.$router.push('/')
            }
        }else{
            toasterError(`Le service est momentanément indisponible`,'Service indisponible')
        }
        return false
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default {
    toasterError,
    toasterSuccess,
    downloadCdr,
    createDraftInvoices,
    valorisation,
    deleteDraftInvoices,
}